export default "__VITE_PUBLIC_ASSET__60c2ea78__"